export const SETTING_QUERY_KEYS = {
  listNotificationSettings: ['settingNotifications'] as const,
  portalSettings: ['portalSettings'] as const,
};
